import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Logo from "../../../Assets/img/the-paperboy-logo-5.png"


const SignUp = () => {
    const navigate = useNavigate();
    const [showNavBar, setShowNavbar] = useState(true);


    return (
        <div className="container mt-3 bg-white p-3 mb-3" style={{ minHeight: '100vh' }}>
            <div className="col-7 col-md-4 " style={{ marginLeft: '500px', marginBottom:'150px' }}>
                <div className="logo-text ">
                    <h1 className="logo text-uppercase d-md-inline d-none" onClick={() => setShowNavbar(true)}>
                        <Link to="/">
                            <img src={Logo} alt="" />
                        </Link>
                    </h1>
                    <h1 className="logo logo-mobile text-uppercase d-inline d-md-none">
                        <Link to="/" className="ms-1">
                            <img src={Logo} alt="" />
                        </Link>
                    </h1>
                </div>
            </div>
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: '100%' }}
            >
                <div className="text-center">
                    <h1>Become a Paperboy or Papergirl today!</h1>
                    <h2>
                        Make an income by sharing news items with your friends who agree to also share the news.
                    </h2>
                    <div className="btn-user mt-2">
                        <button className="btn text-white btn-dark rounded-3"
                            onClick={() => navigate('/signup-form')}
                        >
                            SIGN UP HERE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignUp;
